<google-map height="100%" width="100%" [options]="mapOptions" (boundsChanged)="boundsChanged()" [center]="center!">
  <ng-container *ngIf="showFields">
    <map-polygon *ngFor="let field of fields" [paths]="fieldToVertices(field)"
      [options]="getPolygonOptions(field)" (polygonClick)="onPolygonClick(field)"></map-polygon>
  </ng-container>
  <map-info-window></map-info-window>
</google-map>
